import { apiService } from './apiService';
import { FindUserRequest, FindUserResponse } from '../types';

class UserLookupService {
  /**
   * Find a user by their license plate number
   * Only available for Telegram users
   */
  async findUserByLicensePlate(licensePlate: string): Promise<FindUserResponse> {
    const request: FindUserRequest = {
      licensePlate: licensePlate.trim()
    };

    try {
      const response = await apiService.post<FindUserResponse>('/user-lookup/find-by-plate', request);
      return response;
    } catch (error: any) {
      // Handle API errors gracefully
      console.error('Find User API Error:', error);
      
      let errorMessage = 'Failed to search for user. Please try again.';
      
      if (error.response) {
        // Server responded with error status
        const status = error.response.status;
        const responseData = error.response.data;
        
        if (status === 500) {
          errorMessage = 'Server error occurred. Please try again later.';
        } else if (status === 404) {
          errorMessage = 'User not found with this license plate.';
        } else if (status === 401 || status === 403) {
          errorMessage = 'You are not authorized to search for users.';
        } else if (status === 400) {
          errorMessage = responseData?.message || 
                        responseData?.errorMessage || 
                        'Invalid license plate format.';
        } else {
          errorMessage = responseData?.message || 
                        responseData?.errorMessage || 
                        `Server error (${status}). Please try again.`;
        }
      } else if (error.request) {
        // Network error
        errorMessage = 'Network error. Please check your connection and try again.';
      } else {
        // Other error
        errorMessage = error.message || 'An unexpected error occurred.';
      }
      
      return {
        isSuccess: false,
        errorMessage,
        notificationSent: false
      };
    }
  }
}

export const userLookupService = new UserLookupService();